(function () {
  function init() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.new-arrivals-editorial').forEach(function (el) {
      var swiperEl = el.querySelector('.new-arrivals-editorial__swiper');
      if (!swiperEl || swiperEl.swiper) return;

      new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        slidesPerGroup: 1,
        grabCursor: true,
        simulateTouch: true,
        touchEventsTarget: 'container',
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true
        },
        navigation: {
          prevEl: el.querySelector('.new-arrivals-editorial__nav--prev'),
          nextEl: el.querySelector('.new-arrivals-editorial__nav--next')
        },
        breakpoints: {
          375: { slidesPerView: 1.2, spaceBetween: 5, slidesPerGroup: 1 },
          700: { slidesPerView: 2.2, spaceBetween: 5, slidesPerGroup: 1 },
          1000: { slidesPerView: 3, spaceBetween: 5, slidesPerGroup: 1 },
          1440: { slidesPerView: 4, spaceBetween: 5, slidesPerGroup: 1 }
        }
      });
    });
  }

  if (typeof Swiper !== 'undefined') { init(); }
  if (document.readyState === 'complete') { init(); }
  else { window.addEventListener('load', init); }
})();